import { createSelector } from 'reselect';
import { initialState } from './reducer';

const selectParlingoContainerDomain = (state: any) => state.parlingoContainer || initialState;

const selectParlingoGames = () => createSelector(selectParlingoContainerDomain, (substate) => substate.games);

const selectIsLoading = () => createSelector(selectParlingoContainerDomain, (substate) => substate.isLoading);

const selectError = () => createSelector(selectParlingoContainerDomain, (substate) => substate.error);

const selectPreviewData = () => createSelector(selectParlingoContainerDomain, (substate) => substate.previewData);

const selectAvailableFixtures = () =>
  createSelector(selectParlingoContainerDomain, (substate) => substate.availableFixtures);

const selectIsLoadingFixtures = () =>
  createSelector(selectParlingoContainerDomain, (substate) => substate.isLoadingFixtures);

const selectGetParlingoDifficultyOddsRange = () =>
  createSelector(selectParlingoContainerDomain, (substate) => substate.difficultyOddsData);

const selectGetAcceptedMarketDatalist = () =>
  createSelector(selectParlingoContainerDomain, (substate) => substate.acceptedMarketData);

// Pagination selectors
const selectCurrentPage = () => createSelector(selectParlingoContainerDomain, (substate) => substate.currentPage);

const selectPageSize = () => createSelector(selectParlingoContainerDomain, (substate) => substate.pageSize);

const selectTotalCount = () => createSelector(selectParlingoContainerDomain, (substate) => substate.totalCount);

const selectTotalPages = () => createSelector(selectParlingoContainerDomain, (substate) => substate.totalPages);

const selectCurrentStatus = () => createSelector(selectParlingoContainerDomain, (substate) => substate.currentStatus);

export {
  selectParlingoGames,
  selectIsLoading,
  selectError,
  selectPreviewData,
  selectAvailableFixtures,
  selectIsLoadingFixtures,
  selectCurrentPage,
  selectPageSize,
  selectTotalCount,
  selectTotalPages,
  selectCurrentStatus,
  selectGetParlingoDifficultyOddsRange,
  selectGetAcceptedMarketDatalist
};
